import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5032e118"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id", "data-cy"]

import store from "@/store";
import utilities from "@/utils/utilities";
import { computed } from "vue";

import upArrowVectorIcon from "@/components/svgs/upArrowVectorIcon.vue";
import downArrowVectorIcon from "@/components/svgs/downArrowVectorIcon.vue";
import ArrowRightIcon from "@/components/svgs/arrowRightIcon.vue";
import VendorAssessmentChecklistStatusTag from "../vendor/vendorAssessmentChecklistStatusTag.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'customDropDownItem',
  props: {
  idText: {
    type: String,
    required: true,
  },
  style: {
    type: String,
    default: "normal",
  },
  addIcon: {
    type: Boolean,
    default: false,
  },
  transFormRotate: {
    type: Number,
    default: 90,
  },
  isLastItem: {
    type: Boolean,
    default: false,
  },
  styleText: {
    type: String,
    default: "",
  },
  padding: {
    type: String,
    default: "tw-p-[15px]",
  },
  idItem: {
    type: String,
    default: "",
  },
  arrowIconStyle: {
    type: String,
    default: "",
  },
  customClass: {
    type: String,
    default: "",
  },
  customTextClass: {
    type: String,
    default: "",
  },
  tagIsArchived: {
    type: Boolean,
    default: false,
  },
  tagStatus: {
    type: String,
    default: "",
  },
  tagStatusId: {
    type: String,
    default: "",
  },
  dataCyId: {
    type: String,
    default: "",
  },
  isShowOption: {
    type: Boolean,
    default: true,
  },
},
  setup(__props) {

const props = __props;



const defaultUiText = computed(() => store.state.LanguagePicker.defaultUiText);
const languageSelectedText = computed(
  () => store.state.LanguagePicker.languageSelectedText,
);

const getUiText = (id: string, isArray = false) => {
  return utilities.getUiText(
    id,
    languageSelectedText.value,
    defaultUiText.value,
    isArray,
  );
};

return (_ctx: any,_cache: any) => {
  return (__props.isShowOption)
    ? (_openBlock(), _createElementBlock("span", {
        key: 0,
        id: __props.idItem,
        "data-cy": __props.dataCyId,
        class: _normalizeClass(`custom-drop-down-item tw-whitespace-nowrap basic-text ${__props.padding} ${
      props.style
    }-text ${__props.addIcon ? 'sort-text tw-items-center' : ''} ${
      __props.isLastItem ? '!tw-border-b-0' : ''
    } ${props.styleText} ${__props.customClass} hover:tw-bg-[#F2F8FF80]`)
      }, [
        _createElementVNode("span", {
          class: _normalizeClass(`${__props.customTextClass}`)
        }, [
          _createTextVNode(_toDisplayString(getUiText(props.idText)) + " ", 1),
          (__props.tagStatus && __props.tagStatusId)
            ? (_openBlock(), _createBlock(VendorAssessmentChecklistStatusTag, {
                key: 0,
                "is-archived": __props.tagIsArchived,
                "checklist-status": __props.tagStatus,
                "checklist-status-id": __props.tagStatusId,
                "is-loading": false
              }, null, 8, ["is-archived", "checklist-status", "checklist-status-id"]))
            : _createCommentVNode("", true)
        ], 2),
        (__props.addIcon && __props.transFormRotate === 90)
          ? (_openBlock(), _createBlock(upArrowVectorIcon, {
              key: 0,
              class: "tw-ml-2 tw-mb-[2px]"
            }))
          : _createCommentVNode("", true),
        (__props.addIcon && __props.transFormRotate === -90)
          ? (_openBlock(), _createBlock(downArrowVectorIcon, {
              key: 1,
              class: "tw-ml-2 tw-mb-[2px]"
            }))
          : _createCommentVNode("", true),
        (__props.arrowIconStyle)
          ? (_openBlock(), _createBlock(ArrowRightIcon, {
              key: 2,
              class: _normalizeClass(`${__props.arrowIconStyle}`)
            }, null, 8, ["class"]))
          : _createCommentVNode("", true)
      ], 10, _hoisted_1))
    : _createCommentVNode("", true)
}
}

})